import React from 'react';
import { Row, Col, Input } from 'reactstrap';
import ReactHtmlParser from 'react-html-parser';
import CommonFunctions from '../RegCommon/CommonFunctions';
import RegItemRadio from './RegitemRadio';
import RegItemCheckbox from './RegItemCheckbox';
import RegItemNumber from './RegItemNumber';
import RegItemdropdown from './RegItemDropdown';
import TravconFunctions from '../RegCommon/CustomerFunctions/TravconFunctions';
import EventcodeFunctions from '../RegCommon/EventcodeFunctions';
// import RegItemStrings from '../RegCommon/RegItemStrings';

var moment = require('moment-timezone');

class RegItemContainer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            regitemid: props.itemid,
            regitem: props.regitem,
            groupname: props.groupname,
            regitemstyle: CommonFunctions.getRegItemStyle()
        }
        //console.log(this.state);
        this.refreshComponent = this.refreshComponent.bind(this);
    }

    refreshComponent() {
        //console.log("refresh");
        this.props.refreshComponent();
    }

    render() {
        var regitem = this.state.regitem;

        // Validate the regitem date and show/hide the reg item
        var disableregitem = this.validateRegItemDate(regitem);

        return (
            <div key={regitem.data5} hidden={disableregitem}>
                <Row>
                    <Col md={6}>
                        {this.renderRegItemTitle(regitem)}
                    </Col>
                    <Col md={3} className="reg-price">
                        {this.renderRegItemPrice(regitem)}
                    </Col>
                    <Col md={3}>
                        {this.renderRegItemInput(regitem, disableregitem, this.state.groupname)}
                    </Col>
                </Row>
            </div>
        )
        return null
    }

    validateRegItemDate(item) {
        var result = false;
        //console.log(item);
        if (item.begindate != " " && item.enddate != " ") {
            var startdate = Date.parse(moment(item.begindate).format('L'));
            var finishdate = Date.parse(moment(item.enddate).format('L'));
            var timezonedate = Date.parse(moment().tz(`${global.$settings.timezone}`).format('L'));

            if ((timezonedate) >= (startdate) && (timezonedate) <= (finishdate)) {
                result = false;
            }
            else {
                result = true;
            }
        }

        return result;
    }

    validateRegItemCount(item, maxsignups, currentsignups) {
        var itemsoldout = false;

        // Get Platinum booth available count
        
        // For dropdown items
        if (item.data4 == "dropdownprice" || item.data4 == "multiselect") {
            var result = false;
            global.$regdropdownoptions.map(dropdownitem => {
                if (item.data2.includes(dropdownitem.data5)) {
                    var maxsignup = dropdownitem.maxsignups;
                    var currentsignup = dropdownitem.currentsignups;
                    
                    if ((Number(maxsignup) - Number(currentsignup)) > Number(0)) {
                        result = true;
                    }
                }
            })
            if (result == true) {
                itemsoldout = false;
            }
            else {
                itemsoldout = true;
            }
        }
        else { // for regular items

            if (EventcodeFunctions.isTravconExhibitor2023(global.$code) && item.name.includes("Platinum")) {
                
                //TravConExhibior - All platinum options share a max count. 

                var avalilablecount = TravconFunctions.getAvailableSignupsForPlatinumBooths();
                //console.log(avalilablecount, Number(avalilablecount) > Number(0))
                if (Number(avalilablecount) > Number(0)) {
                    itemsoldout = false;
                }
                else {
                    itemsoldout = true;
                }
            }
            else {
                if (Number(maxsignups) - Number(currentsignups) > Number(0)) {
                    itemsoldout = false;
                }
                else {
                    itemsoldout = true;
                }
            }
        }

        return itemsoldout;
    }
    getRegItemRemainingCount(regitem, maxsignups, currentsignups) {
        var signupsremaining = "";
        if (Number(maxsignups) < Number(10000)) {
            var signupscount = Number(maxsignups) - Number(currentsignups);

            // Get Platinum booth available count
            var avalilablecount = TravconFunctions.getAvailableSignupsForPlatinumBooths();
            if (regitem.name.includes("Platinum")) {
                signupsremaining = avalilablecount + " Available";
            }
            else {
                signupsremaining = signupscount + " Available";
            }
        }
        else {
            signupsremaining = "";
        }
        return signupsremaining;
    }

    /*
        regitem:
            data3 - price
            currency - dollar } rupee 

        retunrs $10 or R10
    */

    getRegItemPrice(item) {
        var itemprice = "";
        if (item.amount == 0) {
            itemprice = item.data3;
        }
        else {
            if (item.currency.includes("dollar")) {
                itemprice = "$" + item.amount;
            }
            else if (item.currency.includes("rupee")) {
                itemprice = "&#8377;" + item.amount;
            }
            else {
                itemprice = "$" + item.amount;
            }
        }
        return itemprice;
    }

    /*
        regitem.code - Has json format for new item text 

        {   
            "newlabel": {     
                "required": true,     
                "text": "<p style='font-size: 12px; padding: 4px 5px 3px 4px; marginTop: -10px; margin-left: 6px; margin-bottom: -20px; background-color: #41a0ba; color: white; font-weight: 600; border-radius: 4px'>New</p>" 
                } 
        }
    
    */

    getRegItemJson(item) {
        var itemjson = "";
        if (item.code != "" && item.code != " ") {
            itemjson = item.code;
            itemjson = JSON.parse(itemjson)
        }
        return itemjson;
    }

    renderRegItemTitle(item) {

        // This is to show the regitem new label
        // get the regitem json from code field 
        var itemjson = this.getRegItemJson(item);

        return (
            <div>
                <p className="attendee-reg-item" style={this.state.regitemstyle}>{item.name}
                    {
                        item.code != "" && item.code != " " && itemjson.newlabel.required == true ?
                            (
                                <p><div dangerouslySetInnerHTML={{ __html: itemjson.newlabel.text }}></div></p>
                            )
                            :
                            ('')
                    }
                </p>
                <p className="attendee-reg-item-desc">{ReactHtmlParser(item.desc)}</p>
            </div>
        )
    }
    renderRegItemPrice(item) {
        // Get the reg item price
        var itemprice = this.getRegItemPrice(item);

        // If the re item is no guest then don't display the price
        if (item.data3 == "noguest") {
            return "";
        }
        else {
            return (
                <div className="reg-price">
                    <div dangerouslySetInnerHTML={{ __html: itemprice }}></div>
                </div>
            )
        }
    }
    renderRegItemInput(regitem, disableregitem, groupname) {

        var maxsignups = regitem.maxsignups;
        var currentsignups = regitem.currentsignups;

        // Validate the regitem current/max signups and make the item sold out
        var itemsoldout = this.validateRegItemCount(regitem, maxsignups, currentsignups);

        // Check the max/current signups and get theremaining count 
        var signupsremaining = this.getRegItemRemainingCount(regitem, maxsignups, currentsignups);

        // this is a dynamic state variable based on ID for quantity
        // This is to store the quantity value 
        var quantityvalue = regitem.data5 + 'value';
        if (this.state[quantityvalue] == "" || this.state[quantityvalue] == null) {
            this.state[quantityvalue] = "0";
        }

        if (itemsoldout) {
            return (
                <div className="regitem-soldout">SOLD OUT</div>
            )
        }
        else {
            if (CommonFunctions.isRadioInput(regitem)) {
                return (
                    <RegItemRadio regitem={regitem} signupsremaining={signupsremaining} disableregitem={disableregitem} groupname={groupname} refreshComponent={this.refreshComponent} />
                )
            }
            else if (CommonFunctions.isCheckboxInput(regitem)) {
                return (
                    <RegItemCheckbox regitem={regitem} signupsremaining={signupsremaining} disableregitem={disableregitem} groupname={groupname} refreshComponent={this.refreshComponent} />
                )
            }
            else if (CommonFunctions.isNumberInput(regitem)) {
                return (
                    <RegItemNumber regitem={regitem} signupsremaining={signupsremaining} disableregitem={disableregitem} groupname={groupname} quantityvalue={quantityvalue} refreshComponent={this.refreshComponent} />
                )
            }
            else if (CommonFunctions.isDropdownInput(regitem)) {
                return (
                    <RegItemdropdown regitem={regitem} signupsremaining={signupsremaining} disableregitem={disableregitem} groupname={groupname} refreshComponent={this.refreshComponent} />
                )
            }
        }
    }
}

export default RegItemContainer;